<template>
  <div ref="component" class="container cx_style" @click.stop>
    <div class="container-wrap">
      <div class="title">
        <span class="icon icon-portal-no-color" @click="changeBgColor(0, 'rgba(255,255,255,0)')"></span>
        <span class="fs14"  @click="changeBgColor(0, 'rgba(255,255,255,0)')">无背景色</span>
      </div>
      <ul class="color-box">
        <li class="color" v-for="(color, index) in colorList" :key="index" :style="getColorStyle(color)"
          @click="changeBgColor(0, color)"></li>
      </ul>
      <div v-for="(bg, index) in backgroundVal" v-if="bg.type === 'color'" :key="index" class="color-container">
        <div class="bg-style-list">
          <div class="bg-scan" :class="bg.isThemeColor ? 'disable' : ''">
            <span v-if="bg.isThemeColor" class="color-scan linearGradient-span el-color-picker__color is-alpha">
              <span :style="getThemeColor"></span>
            </span>
            <span v-else class="color-scan linearGradient-span el-color-picker__color is-alpha">
              <span :style="getColor(bg.color)"></span>
            </span>
            <span v-if="bg.isThemeColor" class="floatLeft color-text mr6">主题色</span>
            <el-input v-else type="text" class="color-input" v-model="colorText" @focus="getFocus($event)"
              @input="changeBgColor(2, $event)" @blur="visibleVal = false"/>
            <el-tooltip class="item" effect="dark" :open-delay="1000" :content="bg.isThemeColor ? '解除绑定' : '绑定主题色'"
              placement="top">
              <span @click.stop="changeBgColor(1)" class="input-icon bind-icon right-handle-icon"
                :class="bg.isThemeColor ? 'icon-portal-unbind' : 'icon-portal-binding'"></span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="shape" @click.stop="visibleVal=false"></div>
  </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"
import { simpleDeepClone } from "../../utils"
export default {
  mixins: [publicData],
  name: "colorSelector",
  props: {
    background: {
      type: null, //不传string 的原因是 在图表 单色 多色切换的时候 可能还没有获取到值 此时是undefined
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      colorList: ["#131b26", "#474c59", "#8a8b99", "#a9afb8", "#c4c7cc", "#dcddde", "#eeeff0", "#f2f4f7", "#ffffff", "#f33131", "#ff5501", "#f49206", "#ffe45b", "#53cc5c", "#41dad4", "#398bff", "#9c81eb", "#ea2f9c", "#fde6e6", "#ffeae0", "#fef2e1", "#fffbe7", "#E9F8EA", "#E7FAF8", "#E6F0FE", "#F3EEFB", "#FCE6F1", "#FAA2A2", "#FFB28D", "#FECE90", "#FEF3B5", "#B0E8B6", "#A8EDEB", "#A5CAFE", "#D2C5F5", "#F6A0CF", "#F54C4C", "#FF7735", "#FDA839", "#FEE97C", "#75D67D", "#66E0DC", "#61A1FE", "#B099EE", "#EE59AB", "#CF1213", "#D44F0C", "#D47C08", "#D4B106", "#2D9937", "#069B96", "#095FD8", "#7B61C3", "#C31D78"],
      colorText: ""
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor || "#3D82F2"
    },
    getThemeColor() {
      return "background-color:" + this.themeColor
    },
    backgroundVal: {
      get() {
        return this.background
      },
      set(val) {
        this.$emit("update:background", val)
      }
    },
    getColor() {
      return function () {
        let background = this.backgroundVal
        let tmpObj = background.find(item => item.type === "color")
        let bgColor = ""
        if (tmpObj.data && tmpObj.data.stops) {
          bgColor = "background-color:" + tmpObj.data.stops[0][0]
          this.colorText = tmpObj.data.stops[0][0]
        } else if (tmpObj && !tmpObj.data) {
          if (tmpObj.color) {
            bgColor = "background-color:" + tmpObj.color
            this.colorText = tmpObj.color
          } else {
            bgColor = "background-color: rgba(255,255,255,0)"
            this.colorText = "rgba(255,255,255,0)"
          }
        }
        return bgColor
      }
    },
    visibleVal: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit("update:visible", val)
      }
    },
  },
  methods: {
    getColorStyle(color) {
      let outline = color === "#ffffff" ? "1px solid #ebebeb" : "none"
      return {
        background: color,
        outline: outline
      }
    },
    changeBgColor(type, color) {
      let background = simpleDeepClone(this.backgroundVal)
      let bgColor = background.find(item => item.type === "color")
      if (type === 0 || type === 2) {// 修改颜色
        if (bgColor.isThemeColor) {
          bgColor.isThemeColor = !bgColor.isThemeColor
        }
        if (!color.includes("#") && !color.includes("(")) color = "#" + color
        bgColor.color = color
        if (bgColor.data?.stops) bgColor.data.stops[0][0] = color
        background.forEach((item, index) => {
          if (item.type === "color") {
            background[index] = bgColor
          }
        })
      }
      if (type === 1) {// 修改主题色
        bgColor.isThemeColor = !bgColor.isThemeColor
      }
      this.backgroundVal = background
      if (type !== 2) {// 输入框输入值时不关闭弹窗
        this.visibleVal = false
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
  }
}
</script>

<style scoped lang="scss">
.text {
  color: var(--text)
}

::v-deep .bg-style-list .color-scan>span {
  vertical-align: top;
}

.container {
  position: absolute;
  width: 230px;
  top: 33px;
  left: 0;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  text-align: left;
  .container-wrap {
    position: relative;
    z-index: 11;
  }

  .title {
    height: 40px;
    line-height: 38px;
    font-size: 16px;
    padding: 0px 10px;

    .icon {
      font-size: 18px;
      margin-right: 10px;
      width: 18px;
      height: 18px;
      outline: 1px solid #ebebeb;
      color: red;
    }

    .fs14 {
      font-size: 14px;
    }
  }

  .color-box {
    border-bottom: 1px solid var(--borderColorFour);
    padding: 0 6px 4px;
    display: flex;
    flex-wrap: wrap;

    li {
      display: inline-block;
      vertical-align: top;
      width: 18px;
      height: 19px;
      border-radius: 2px;
      margin: 6px 3px;
    }
  }

  .color-container {
    margin: 9px;
  }
}

.bg-style-list {
  >div:not(:last-child) {
    margin-bottom: 8px;
  }

  >div {
    display: flex;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    border-radius: 4px;
    height: 32px;
    background-color: var(--inputBg);
    align-items: center;

    .right-handle-icon {
      display: none
    }

    &:hover {
      background-color: var(--inputNuberHoverThemeBgColor);

      .right-handle-icon {
        display: inline-block;
      }
    }

    &.active {
      border-color: var(--themeColor);
      background-color: var(--dialogBgColor);
    }
  }

  .img-icon,
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 4px;
    z-index: 2;
  }

  .color-scan>span {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  .icon-portal-delete {
    font-size: 15px;
  }

  .bg-scan {
    &.disable {
      cursor: not-allowed;
    }

    .color-text {
      padding-left: 6px;
    }
  }
}

::v-deep .color-input input {
  padding: 0 30px;
  background: transparent;
  border-radius: 4px;
  font-size: 14px;
}
.shape {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
}
</style>
